import { css, CSSObject } from '@emotion/react';
import { useLocation, useNavigate } from '@remix-run/react';
import { Box } from '@spark-web/box';
import { BriefcaseIcon, DocumentTextIcon, LightBulbIcon } from '@spark-web/icon';
import { NavLink } from '@spark-web/nav-link';
import { Stack } from '@spark-web/stack';

import { UserRole } from '@app-types/User';
import { allowedRolesForDocuments } from '@enterprise/service/constants';

import { useAuth } from '~/hooks/useAuth';

const getNavItems = (role: UserRole) => {
  return [
    {
      name: 'Leads',
      route: '/opportunities',
      icon: <LightBulbIcon />,
      isVisible: true,
    },
    {
      name: 'Pipeline',
      route: '/pipeline',
      icon: <BriefcaseIcon />,
      isVisible: true,
    },
    {
      name: 'Lead Import',
      route: '/lead-import',
      icon: <DocumentTextIcon />,
      isVisible: allowedRolesForDocuments.includes(role),
    },
  ];
};

type NavbarProps = {
  styles?: CSSObject;
};

const Navbar = ({ styles }: NavbarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const navItems = getNavItems(user?.role as UserRole);

  return (
    <Stack
      as="nav"
      borderRight="standard"
      background="surface"
      css={css(
        {
          height: '100%',
          position: 'fixed',
          paddingLeft: 15,
          a: {
            textDecoration: 'none',
            height: 50,
            cursor: 'pointer',
          },
        },
        styles,
      )}
      paddingTop="medium"
      gap="xsmall"
      data={{
        testId: 'navbar',
      }}
    >
      {navItems.map(
        ({ name, route, icon, isVisible }) =>
          isVisible && (
            <Box key={name} onClick={() => navigate(route)}>
              {/* Used NavLink component from spark-web but using useNavigate from remix for navigation */}
              {/* @ts-expect-error this is added due to href is required prop for navlink */}
              <NavLink key={name} isSelected={location.pathname === route}>
                {icon}
                {name}
              </NavLink>
            </Box>
          ),
      )}
    </Stack>
  );
};

export default Navbar;
